import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import SpecialistsArticle from '../specialists-article/specialists-article';

const SpecialistsCategory = ({ className, articles }) => (
  <section className={classnames('press-experts', className)}>
    <ul className="press-experts__list">
      {_.map(articles, (article, i) => (
        <SpecialistsArticle key={i} article={article} />
      ))}
    </ul>
  </section>
);

SpecialistsCategory.propTypes = {
  className: PropTypes.string,
  articles: PropTypes.arrayOf(SpecialistsArticle.propTypes.article),
};

SpecialistsCategory.displayName = 'SpecialistsCategory';

export default SpecialistsCategory;
